import {ArenaGameFilterEditor} from "../filters/arena-game-filter-editor";
import {IArenaGameFiltersCategoryEditorViewModel} from "./arena-game-filters-category-editor-view-model.interface";
import {IArenaGameFiltersCategory} from "./arena-game-filters-category.interface";
import {computed} from "mobx";
import {NullableNumber} from "../../../../../common/types/nullable-types";
import {IArenaGameFilterEditorViewModel} from "../filters/arena-game-filter-editor-view-model.interface";
import {CategoryDefinitionId} from "../../filters-categories-definitions/filter-category-definition.interface";

export class ArenaGameFiltersCategoryEditor implements IArenaGameFiltersCategoryEditorViewModel {
    constructor(private readonly arenaGameFilterCategory: IArenaGameFiltersCategory) {
        this._filters = arenaGameFilterCategory.availableFilters.map(f => f.createEditor(this));
    }

    private _filters: ArenaGameFilterEditor[];
    @computed
    get visibleFilters(): ArenaGameFilterEditor[] {
        return this._filters.filter(f => f.shouldBeDisplayed);
    }

    get id(): CategoryDefinitionId {
        return this.arenaGameFilterCategory.id;
    }

    get title(): string {
        return this.arenaGameFilterCategory.title;
    }

    getAppliedFiltersIds(): string[] {
        let res = this._filters.filter(f => f.on).map(f => f.id);

        for (let i = 0; i < this.subCategories.length; i++) {
            const subCategoryFilterIds =this.subCategories[i].visibleFilters.filter(f => f.on).map(f => f.id);
            res = res.concat(subCategoryFilterIds);
        }

        return res;
    }

    get gamesCount(): NullableNumber {
        return this.arenaGameFilterCategory.gamesCount;
    }

    get isMultiSelect(): boolean {
        return this.arenaGameFilterCategory.isMultiSelect;
    }

    _subCategories: IArenaGameFiltersCategoryEditorViewModel[];
    get subCategories(): IArenaGameFiltersCategoryEditorViewModel[] {

        if (!this._subCategories) {
            this._subCategories = this.arenaGameFilterCategory.subCategories.map(subCat => new ArenaGameFiltersCategoryEditor(subCat));
        }

        return this._subCategories;
    }

    getAllAppliedFilters(): IArenaGameFilterEditorViewModel[] {
        const appliedFilters = [
            ...this.visibleFilters,
            ...this.subCategories.selectMany(subcategory => subcategory.visibleFilters)
        ].filter(f => f.on);
        return appliedFilters;
    }

    resetAll(): void {
        this._filters.forEach(filterEditor => {
            if (filterEditor.on) {
                filterEditor.on = false;
            }
        });
    }

    enableAll(enable: boolean): void {
        this._filters.forEach(filterEditor => {
            filterEditor.disabled = !enable;
        });
    }

}